/* eslint-disable import/no-extraneous-dependencies */
import { WithStyles } from '@mui/styles';
import {
    APIConnectionRecord, APIConnectionUsersRecord, FirmSecondaryApiTypeRecord, UserSecondaryApiTypeRecord
} from '@tassat/fred-definitions';
import { FirmRecord, UserRecord, UserValidationRecord } from '@tassat/payments-definitions';
import { ActionTypes, SelectOption } from '@tassat/ui-definitions';
import { FormikProps } from 'formik';
import React from 'react';

import { muiStyles } from './styles';

export const isUserRecord = (data: UserValidationRecord | UserRecord): data is UserRecord => {
    return (data as UserRecord)?.UserId !== undefined;
};

export type SubmitClientUserOpts = {
    actionType: ActionTypes;
    userId?: string;
    firmId: string;
    setSubmitError: React.Dispatch<React.SetStateAction<string>>;
    onClose?: () => void;
    firmName?: string;
    secondaryApiFeatureEnabled?: boolean;
    initialValues: IFormValues;
};

export interface ClientUserFormProps {
    users: {
        [key: string]: UserRecord;
    };
    firm?: FirmRecord;
    isUserMappedToApiConnection: boolean;
    isAdmin: boolean;
    firmId?: string;
    actionType: ActionTypes;
    editUser?: UserRecord | UserValidationRecord;
    firmListOptions?: SelectOption[];
    features?: {
        SSO?: boolean;
        SSOConfig?: {
            CompanyCodeRequired: boolean;
            CompanyCodeRegEx: string;
        };
        loginType: string;
        isSecondaryApiEnabled?: boolean;
    };
    deleteUser?: (user) => void;
    validateUsernameAsync: (value: string) => Promise<string | null>;
    submitClientUser: (
        values: IFormValues,
        opts: SubmitClientUserOpts
    ) => any;
    firmSecondaryApiConnections?: FirmSecondaryApiTypeRecord[];
    userSecondaryApiConnections?: UserSecondaryApiTypeRecord[];
    isUserMappedToSecondaryApi?: {
        apiConnectionUser: APIConnectionUsersRecord;
        apiConnection: APIConnectionRecord;
    }[];
}
export interface IFormikProps extends WithStyles<typeof muiStyles> {
    onClose?: () => void;
    formProps: ClientUserFormProps;
}

export interface IFormProps extends IFormikProps, FormikProps<IFormValues> {
    submitError: string;
    firm: FirmRecord;
    isUsernameValidated: boolean;
    setIsUsernameValidated: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface IFormValues {
    FirstName: string;
    LastName: string;
    IsTokenAPIUser?: boolean;
    Email: string;
    Phone: string;
    Notes?: string;
    Username: string;
    CompanyCode?: string;
    Firm?: SelectOption;
    APISecondaryConnectionType?: boolean;
}

export interface IErrorValues {
    FirstName: string;
    LastName: string;
    IsTokenAPIUser?: string;
    Email: string;
    Phone: string;
    Notes?: string;
    Username: string;
    CompanyCode?: string;
    Firm?: SelectOption;
    APISecondaryConnectionType?: string;
}